module.exports = __webpack_public_path__ + "static/media/best-of-boston.c7b8a04d.png";